import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  Scrollbar,
  Mousewheel,
  EffectFade,
  Autoplay,
} from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

const heroCarousel = () => ({
  heroBannerCarousel: "",
  init() {
    // this.heroBannerCarousel();
  },
  initHeroBannerCarousel(animDuration) {
    const this_ = this
    const thisCarousel = this_.$el
    const slideDuration = parseInt(animDuration) * 1000
    this_.heroBannerCarousel = new Swiper(thisCarousel, {
      modules: [Navigation, Pagination, EffectFade, Mousewheel, Autoplay],
      ...{
        direction: "horizontal",
        slidesPerView: 1,
        watchSlidesProgress: true,
        allowTouchMove: true,
        simulateTouch: true,
        centeredSlides: false,
        loop: true,
        effect: "fade",
        fadeEffect: { crossFade: true },
        autoplay: {
          delay: slideDuration,
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        },
        speed: 1500,
        pagination: {
          el: ".swiper-pagination",
          clickable: "true",
          type: "bullets",
          renderBullet: function (index) {
            return `<span class="swiper-pagination-bullet">
							<span class="bullet-progress"></span>
						</span>`
          },
        },
        navigation: {
          nextEl: ".carousel-button-next",
          prevEl: ".carousel-button-prev",
        },
        on: {
          slideChange: function () {
            // Get the current active index and the previous active index
            const activeIndex = this.activeIndex
            thisCarousel
              .querySelectorAll(".swiper-pagination-bullet")
              .forEach((bullet, index) => {
                if (index < activeIndex) {
                  bullet.classList.add("previous-slide")
                } else {
                  bullet.classList.remove("previous-slide")
                }
              })
          },
        },
      },
    })
  },
  clickSlideIndex(slideIndex) {
    const this_ = this
    const thisSlidePager = this_.$el
    const thisParentWrapper = thisSlidePager.parentNode
    const thisSectionId = thisParentWrapper.getAttribute("data-section-id")
    const sliderPagination = document.querySelector(
      `.hero-banner .swiper[data-section-id="${thisSectionId}"]`
    )
    this_.heroBannerCarousel.slideTo(slideIndex, 400, false)
  },
})

export default heroCarousel
